import { GuarantorOption } from "@common";
import { useNavigate } from 'react-router-dom';
import { ChevronRightIcon } from "@icons";
import managePaymentsImg from "@illustrations/manage-payments-144x144.png";
import payorsImg from "@illustrations/payors-144x144.png";

const MyAccount = () => {

    const navigate = useNavigate();

    return (
        <div className="flex flex-col w-full">
            {/* Header */}
            <div className="border-b border-neutral-100 pb-6 mb-8">
                <h1 className="text-[20px] leading-[24px] md:text-[28px] md:leading-[40px] font-medium text-neutral-950 tracking-[0.2px] md:tracking-[0.28px]">
                    Settings
                </h1>
            </div>

            {/* Settings Cards */}
            <div className="flex flex-col gap-4">
                {/* Payment Settings Card */}
                <button
                    type="button"
                    onClick={() => navigate(`/payment-method-settings`)}
                    className="bg-white border border-neutral-100 hover:border-neutral-200 rounded-xl p-4 flex items-center transition-colors focus-visible:outline-focus-ring text-left"
                >
                    <div className="w-20 flex items-center justify-center flex-shrink-0 mr-4">
                        <img
                            src={managePaymentsImg}
                            alt="Illustration of a bank and credit/debit cards"
                            className="w-[72px] h-[72px]"
                        />
                    </div>
                    <div className="flex-1 flex flex-col gap-1">
                        <h2 className="text-base leading-6 font-medium text-neutral-950 tracking-[0.32px]">
                            Payment Settings
                        </h2>
                        <p className="text-xs leading-4 md:text-sm md:leading-5 text-neutral-700 tracking-[0.12px] md:tracking-[0.14px]">
                            Manage payment methods, autopay, and when payments go through.
                        </p>
                    </div>
                    <ChevronRightIcon className="w-5 h-5 text-neutral-900 flex-shrink-0 ml-6 md:ml-10" />
                </button>

                {/* Manage Payors Card */}
                <GuarantorOption>
                    <button
                        type="button"
                        onClick={() => navigate(`/manage-payors`)}
                        className="bg-white border border-neutral-100 hover:border-neutral-200 rounded-xl p-4 flex items-center transition-colors focus-visible:outline-focus-ring text-left"
                    >
                        <div className="w-20 flex items-center justify-center flex-shrink-0 mr-4">
                            <img
                                src={payorsImg}
                                alt="Illustration of several persons' hands high-fiving"
                                className="w-[72px] h-[72px]"
                            />
                        </div>
                        <div className="flex-1 flex flex-col gap-1">
                            <h2 className="text-base leading-6 font-medium text-neutral-950 tracking-[0.32px]">
                                Manage Payors
                            </h2>
                            <p className="text-xs leading-4 md:text-sm md:leading-5 text-neutral-700 tracking-[0.12px] md:tracking-[0.14px]">
                                Add and delete Payors and set dates and amounts for active Payors.
                            </p>
                        </div>
                        <ChevronRightIcon className="w-5 h-5 text-neutral-900 flex-shrink-0 ml-6 md:ml-10" />
                    </button>
                </GuarantorOption>
            </div>
        </div>
    );
};

export default MyAccount;
